<template>
  <a-modal
    title="取消要货通知单"
    width="85%"
    :visible="visible"
    okText="确认"
    :destroyOnClose="true"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <a-form-model ref="baseForm" class="baseForm" :model="formData">
      <ls-metable
        class="allocationTable"
        :columns="columns"
        :data-list="formData.infos"
        :scroll="{y:400}"
        :customRow="(record, index) => index"
        :IsEdit="false"
        :needAdd="false"
      >
        <template slot="quantityTitle">
          <i class="toRequired">*</i>取消数量
        </template>
        <template slot="cancelReasonTitle">
          <i class="toRequired">*</i>取消原因
        </template>
        <template slot="quantity" slot-scope="{text,record,index}">
          <a-form-model-item
            :prop="`infos.${index}.quantity`"
            :rules="{'required':true,'message':' ','trigger':'blur'}"
          >
            <a-input-number v-if="record.executeStatus==='S'" v-model="record.quantity" :disabled="record.executeStatus==='S'"/>
            <a-input-number v-else v-model="record.quantity" :min="0" :max="record.cancellableQuantity"/>
          </a-form-model-item>
        </template>
        <template slot="cancelReason" slot-scope="{text,record,index}">
          <a-form-model-item
            :prop="`infos.${index}.cancelReason`"
            :rules="{'required':true,'message':' ','trigger':'blur'}"
          >
            <a-input type="textarea" :disabled="record.executeStatus==='S'" v-model="record.cancelReason" :maxLength="200" :autoSize="{minRows:2}" />
          </a-form-model-item>
        </template>
        <template slot="executeStatusName" slot-scope="{text,record}">
          <span>{{ record.executeStatus ? executeStatusEnum[record.executeStatus] : '待确认' }}</span>
        </template>
        <template slot="operation" slot-scope="{text,record}">
          <a :disabled="record.executeStatus==='S'" @click="onDelete(record)">删除</a>
        </template>
      </ls-metable>
    </a-form-model>
    <template slot="footer">
      <a-button type="primary" :loading="confirmLoading" @click="confirm">确认</a-button>
    </template>
  </a-modal>
</template>

<script>
import cloneDeep from 'lodash.clonedeep'
import {
  apiPoDeliveryNoticeLinesClose
} from '@/api/scp/reserve-goods-plan/for-goods-manage'
export default {
  name: 'CancelModal',
  data() {
    return {
      visible: false,
      confirmLoading: false,
      executeStatusEnum: { 'S': '成功', 'E': '失败' },
      formData: { infos: [] },
      isAfterRequest: false, // 判断是否已触发请求
      columns: [
        {
          title: '供应商',
          dataIndex: 'supplierName',
          align: 'center',
          width: 120
        },
        {
          title: '要货单号',
          dataIndex: 'deliveryNotice',
          align: 'center',
          width: 120
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center',
          width: 120
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '双方确认数量',
          dataIndex: 'confirmedQuantity',
          align: 'center',
          width: 120
        },
        {
          title: '未发货量',
          dataIndex: 'quantityUnshipped',
          align: 'center',
          width: 100
        },
        {
          title: '可取消量',
          dataIndex: 'cancellableQuantity',
          align: 'center',
          width: 100
        },
        {
          // title: '取消数量',
          dataIndex: 'quantity',
          scopedSlots: { customRender: 'quantity', title: "quantityTitle" },
          width: 150,
          align: 'center',
          type: "inputNumber"
        },
        {
          // title: '取消原因',
          dataIndex: 'cancelReason',
          scopedSlots: { customRender: 'cancelReason', title: "cancelReasonTitle" },
          width: 150,
          align: 'center',
          type: "input"
        },
        {
          title: '执行状态',
          dataIndex: 'executeStatusName',
          scopedSlots: { customRender: 'executeStatusName' },
          align: 'center',
          width: 100
        },
        {
          title: '备注',
          dataIndex: 'remark',
          align: 'center',
          width: 120
        },
        {
          title: '操作',
          width: 60,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ]
    }
  },
  methods: {
    // 展示
    show (data) {
      this.isAfterRequest = false;
      this.formData.infos = [];
      this.formData.infos = cloneDeep(data);
      this.formData.infos.map(item => {
         item.quantity = item.cancellableQuantity
      })
      this.visible = true
    },
    // 关闭
    close() {
      this.formData.infos = []
      this.visible = false
      this.$emit('closeCancel', this.isAfterRequest) // 刷新数据，但不切分页
      this.isAfterRequest = false;
    },
    // 确认
    confirm() {
      this.$refs.baseForm.validate(valid => {
        if(valid) {
          const apiData = []
          // 只入参未成功或未提交的单据
          this.formData.infos.forEach(v => {
            if (v.executeStatus !== 'S') {
              apiData.push({
                ...v,
                quantityCancelled: v.quantity, // 填写的取消数量
                closeReason: v.cancelReason // 回填到原关闭原因字段上
              })
            }
          })
          if(apiData?.length < 1) {
            this.$message.warning('请选择有效数据')
            return
          }
        this.confirmLoading = true;
          apiPoDeliveryNoticeLinesClose(apiData).then(res => {
            // 清空备注
            this.formData.infos.forEach(obj => {
              obj.remark = ''
            })
            this.isAfterRequest = true; // 已正常请求
          if(res.code !== 200) { return }
           let isErr = false
            res.data.forEach(val => {
              const getIndex = this.formData.infos.findIndex(info => info.id === val.drRowId)
              if (getIndex !== -1) {
                this.formData.infos[getIndex].cancellableQuantity = val.cancellableQuantity; // 取接口最新的可取消数量
                this.formData.infos[getIndex].executeStatus = val.executeStatus; // 记录是否成功标识
                this.formData.infos[getIndex].confirmedQuantity = val.bothEnsureQuantity; // 双方确认数量
                this.formData.infos[getIndex].quantityUnshipped = val.unDeliveryQuantity; // 未发货量
                if (val.executeStatus === 'E') {
                  isErr = true
                  this.formData.infos[getIndex].remark = val.executeFailMsg // 记录错误信息
                }
              }
            })
            this.$forceUpdate()
            if(isErr) {
              this.$message.error('部分数据取消失败! 请看备注提示')
            }else{
              this.$message.success('操作成功')
            }
          }).finally(() => {
            this.confirmLoading = false;
          })
        } else { this.$message.warning('请检查必填项') }
      });
    },
    // 删除
    onDelete(row) {
      const getIndex = this.formData.infos.findIndex(v => v.id === row.id)
      if(getIndex !== -1) {
        this.formData.infos.splice(getIndex, 1);
      }
    }
  }
}
</script>
